export default {
  path: '/setup_definition_subs',
  name: 'setup_definition_subs',
  component: () => import('../components/setupdefinitionsub/Layout'),
  redirect: { name: 'SetupDefinitionSubList' },
  children: [
    /*
    {
      name: 'SetupDefinitionSubList',
      path: '',
      component: () => import('../views/setupdefinitionsub/List')
    },
    {
      name: 'SetupDefinitionSubCreate',
      path: 'new',
      component: () => import('../views/setupdefinitionsub/Create')
    },
    {
      name: 'SetupDefinitionSubUpdate',
      path: ':id/edit',
      component: () => import('../views/setupdefinitionsub/Update')
    },
    {
      name: 'SetupDefinitionSubShow',
      path: ':id',
      component: () => import('../views/setupdefinitionsub/Show')
    }
    */
  ]
};
